const updateAssetsLoading = (state, { payload: { loading } }) => {
	state.loading = loading;
};

export default updateAssetsLoading;
